/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Container } from 'react-bootstrap';
import api from '../../../services/API';
import ModalAlterarStatusResgate from '../ModalAlterarStatusResgate';
import ModalCancelarResgate from '../ModalCancelarResgate';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Row, Col } from 'react-bootstrap';
import sortFunc from '../../../utils/ordernarColunaInt';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import ModalMassRescueAlteration from './ModalMassRescueAlteration';
import ModalObsEdit from './ModalObsEdit';
import ModalEditarPrevisaoEntrega from './ModalEditarPrevisaoEntrega';
import { toast } from 'react-toastify';

export default function Resgates() {
  const usuario = useSelector((state) => {
    return state.usuario;
  });
  const [redesSelect, setRedesSelect] = useState([]);
  const [redeSelecionada, setRedeSelecionada] = useState([]);
  const [gestoresSelect, setGestoresSelect] = useState([]); 
  const [gestorSelecionado, setGestorSelecionado] = useState(''); 
  const [
    mostrarModalAlterarStatusResgate,
    setMostrarModalAlterarStatusResgate,
  ] = useState(false);
  const [mostrarModalCancelarResgate, setMostrarModalCancelarResgate] =
    useState(false);
  const [resgate, setResgate] = useState('');
  const [data, setData] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [showSelectionIdsModal, setShowSelectionIdsModal] = useState(false);
  const [showObsEditModal, setShowObsEditModal] = useState(false);
  const [obs, setObs] = useState('');
  const [showModalPrevisaoEntrega, setShowModalPrevisaoEntrega] = useState(false);
  const [dataEditarPrevisao, setDataEditarPrevisao] = useState(null);
  const [mostrarModalEditarPrevisao, setMostrarModalEditarPrevisao] = useState(false);
  const [resgatesSelecionados, setResgatesSelecionados] = useState([]);
  const [enviando, setEnviando] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [termoBusca, setTermoBusca] = useState('');

  const formatarData = (celula, valor) => {
    return moment(valor.resgatadoEm).format('DD/MM/YYYY HH:mm:ss');
  };

  const formatarQtde = (celula, valor) => {
    return Number(valor.qtde).toLocaleString('pt-BR');
  };

  const formatarSaldo = (celula, valor) => {
    return Number(valor.saldoAnterior).toLocaleString('pt-BR');
  };

  const formatarGasto = (celula, valor) => {
    return Number(valor.pontosGastos).toLocaleString('pt-BR');
  };

  const formatarStatus = (celula, valor) => {
    if (valor.status === 0) {
      return (
        <span>
          <i className="fa fa-clock"></i> Solicitado
        </span>
      );
    } else if (valor.status === 1) {
      return (
        <span>
          <i className="fa fa-check"></i> Sim
        </span>
      );
    } else if (valor.status === 2) {
      return (
        <span>
          <i className="fa fa-truck"></i> Em trânsito
        </span>
      );
    } else if (valor.status === 3) {
      return (
        <span>
          <i className="fa fa-times"></i> Cancelado
        </span>
      );
    }
  };

  const formatarPremioResgatado = (celula, valor) => {
    return valor.obs ? `${valor.premio} - ${valor.obs}` : `${valor.premio}`;
  };

  const handleCheckboxChange = (resgateId, checked) => {
    const id = Number(resgateId);
    setResgatesSelecionados(prev => {
      if (checked) {
        if (prev.includes(id)) return prev;
        const newState = [...prev, id];
        setTableKey(prev => prev + 1);
        return newState;
      } else {
        const newState = prev.filter(selectedId => selectedId !== id);
        setTableKey(prev => prev + 1);
        return newState;
      }
    });
  };

  const enviarManualmente = async () => {
    if (resgatesSelecionados.length === 0) {
      return;
    }

    setEnviando(true);
    const resultados = [];

    for (const resgateId of resgatesSelecionados) {
      try {
        await api.post(`/api/resgates/${resgateId}/enviar-manualmente`, {}, {
          errorHandle: false
        });
        resultados.push({ id: resgateId, sucesso: true });
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.response?.data?.erro || error.message;
        resultados.push({ 
          id: resgateId, 
          sucesso: false, 
          erro: errorMessage
        });
      }
    }

    setEnviando(false);
    setResgatesSelecionados([]);
    
    const sucessos = resultados.filter(r => r.sucesso).length;
    const falhas = resultados.filter(r => !r.sucesso).length;
    const errosDetalhados = resultados.filter(r => !r.sucesso).map(r => r.erro).join('; ');

    if (sucessos > 0 && falhas === 0) {
      toast.success(`Todos os ${sucessos} resgate(s) foram enviados com sucesso!`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else if (sucessos > 0 && falhas > 0) {
      toast.warning(`${sucessos} resgate(s) enviado(s) com sucesso. ${falhas} falha(ram). ${errosDetalhados}`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 15000,
      });
    } else {
      toast.error(`Erro ao enviar os resgates: ${errosDetalhados}`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 15000,
      });
    }

    buscarResgates(1, 10, termoBusca);
  };

  const columns = useMemo(() => [
    {
      text: '',
      isDummyField: true,
      dataField: 'checkbox',
      formatter: (celula, valor) => {
        const isBloqueadoPorAF = valor.bloqueadoPorAF === true;
        const resgateId = Number(valor.id);
        const isSelecionado = valor._isSelected !== undefined ? valor._isSelected : resgatesSelecionados.some(id => Number(id) === resgateId);
        
        return (
          <input
            key={`checkbox-${resgateId}-${isSelecionado ? 'checked' : 'unchecked'}-${tableKey}`}
            type="checkbox"
            checked={isSelecionado}
            disabled={!isBloqueadoPorAF}
            onChange={(e) => {
              e.stopPropagation();
              handleCheckboxChange(resgateId, e.target.checked);
            }}
            title={isBloqueadoPorAF ? 'Marcar para enviar manualmente' : 'Apenas resgates PIX bloqueados pelo AF podem ser enviados manualmente'}
          />
        );
      },
    },
    {
      dataField: 'id',
      text: 'ID',
      sort: true,
    },
    {
      dataField: 'parceiro',
      text: 'Vendedor Loja',
      sort: true,
    },
        {
      dataField: 'gestor',
      text: 'Gestor',
      sort: true,
    },
    {
      dataField: 'revenda',
      text: 'Loja',
      sort: true,
    },
    {
      dataField: 'cidade',
      text: 'Cidade',
      sort: true,
    },
    {
      dataField: 'premio',
      text: 'Produto Resgatado',
      formatter: formatarPremioResgatado,
      sort: true,
    },
    {
      dataField: 'qtde',
      text: 'Quantidade',
      formatter: formatarQtde,
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'obs',
      text: 'Observação',
    },
    {
      dataField: 'saldoAnterior',
      text: 'Saldo no Ato',
      formatter: formatarSaldo,
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'pontosGastos',
      text: 'Pontos Utilizados',
      formatter: formatarGasto,
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'status',
      text: 'Entregue',
      formatter: formatarStatus,
      sort: true,
    },
    {
      dataField: 'resgatadoEm',
      text: 'Data do Resgate',
      formatter: formatarData,
      sort: true,
    },
    {
      dataField: 'previsaoEntrega',
      text: 'Previsão de Entrega',
      sort: true,
      formatter: (cell) => cell ? moment(cell).format('DD/MM/YYYY') : 'Não definida'
    },
    {
      text: 'Alterar Previsão',
      isDummyField: true,
      dataField: 'alterarPrevisao',
      hidden: ![1, 2].includes(usuario.permissao),
      formatter: (celula, valor) => (
        <button
          type="button"
          className="btn-limpo f-12 p-1"
          onClick={() => {
            setDataEditarPrevisao(valor);
            setMostrarModalEditarPrevisao(true);
          }}
        >
          <i className="fas fa-edit" />
        </button>
      ),
    },
    {
      text: 'Alterar Status',
      dataField: 'alterarStatus',
      isDummyField: true,
      hidden: [0].includes(usuario.permissao) ? true : false,
      formatter: (celula, valor) =>
        valor.status !== 3 ? (
          <button
            className="btn-limpo f-12 p-1"
            onClick={() => {
              visualizarModalAlterarStatusResgate(valor.id);
            }}
          >
            <i className="fas fa-edit"></i>
          </button>
        ) : (
          <button className="btn-limpo f-12 p-1" disabled>
            <i className="fas fa-edit"></i>
          </button>
        ),
    },
    {
      text: 'Alterar Observação',
      isDummyField: true,
      dataField: 'changeObs',
      formatter: (celula, valor) => (
        <button
          className="btn-limpo f-12 p-1"
          onClick={() => {
            setObs(valor.obs);
            setResgate(valor.id);
            setShowObsEditModal(true);
          }}
        >
          <i className="fas fa-edit"></i>
        </button>
      ),
      sort: true,
    },
    {
      text: 'Cancelar Resgate',
      isDummyField: true,
      dataField: 'cancelarResgate',
      hidden: [0].includes(usuario.permissao) ? true : false,
      formatter: (celula, valor) =>
        valor.status !== 3 ? (
          <button
            className="btn-limpo f-12 p-1"
            onClick={() => {
              visualizarModalCancelarResgate(valor.id);
            }}
          >
            <i className="fas fa-times f-red"></i>
          </button>
        ) : (
          <button className="btn-limpo f-12 p-1" disabled>
            CANCELADO
          </button>
        ),
    },
    {
      dataField: 'gestor',
      text: 'Gestor',
      sort: true,
    },
  ], [resgatesSelecionados, usuario.permissao, tableKey]);

  const defaultSorted = [
    {
      dataField: 'resgatadoEm',
      order: 'desc',
    },
  ];

  const buscarGestores = async () => {
    const resultado = await api.get('/api/gestores');
    if (resultado) {
      setGestoresSelect(resultado.data);
    }
  };

  useEffect(() => {
    buscarRedes();
    buscarResgates(1, 10, termoBusca);
    buscarGestores();
  }, []);

  const buscarRedes = async () => {
    let todasRedes = [];
    let cursor = null;
    let hasNext = true;
    
    while (hasNext) {
      const url = cursor 
        ? `/api/redes?ativo=1&limit=100&cursor=${cursor}&direction=next`
        : '/api/redes?ativo=1&limit=100';
      
      const resultado = await api.get(url);
      if (resultado && resultado.data.redes) {
        todasRedes = [...todasRedes, ...resultado.data.redes];
        hasNext = resultado.data.pagination?.hasNext || false;
        cursor = resultado.data.pagination?.nextCursor || null;
      } else {
        hasNext = false;
      }
    }
    
    setRedesSelect(todasRedes);
  };

  useEffect(() => {
    if (buscando) {
      setData([]);
    }
  }, [buscando]);

  const buscarResgates = async (page = 1, limit = 10, busca = '') => {
    setBuscando(true);
    let params = {
      rede: redeSelecionada,
      page: page,
      limit: limit,
    };
    if (gestorSelecionado) {
      params.gestorNome = gestorSelecionado; 
    }
    if (busca && busca.trim()) {
      params.search = busca.trim();
    }
    const searchParams = new URLSearchParams(params);
    const resultado = await api.get(`/api/resgates?${searchParams.toString()}`);
    if (resultado) {
      setData(resultado.data.resgates);
      if (resultado.data.pagination) {
        setTotalItems(resultado.data.pagination.totalCount);
        setTotalPages(resultado.data.pagination.totalPages);
        setCurrentPage(resultado.data.pagination.currentPage);
        setPageSize(resultado.data.pagination.limit);
      }
    }
    setBuscando(false);
  };

  const visualizarModalAlterarStatusResgate = (id) => {
    setResgate(id);
    setMostrarModalAlterarStatusResgate(true);
  };

  const fecharModalAlterarStatusResgate = () => {
    setMostrarModalAlterarStatusResgate(false);
  };

  const visualizarModalCancelarResgate = (id) => {
    setResgate(id);
    setMostrarModalCancelarResgate(true);
  };

  const fecharModalCancelarResgate = () => {
    setMostrarModalCancelarResgate(false);
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    if (type === 'pagination') {
      buscarResgates(page, sizePerPage, termoBusca);
    }
  };

  const options = {
    page: currentPage,
    sizePerPage: pageSize,
    totalSize: totalItems,
    showTotal: true,
    sizePerPageList: [
      {
        text: '5',
        value: 5,
      },
      {
        text: '10',
        value: 10,
      },
      {
        text: '25',
        value: 25,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: '100',
        value: 100,
      },
    ],
    paginationTotalRenderer: (from, to, size) =>
      size > 0 ? (
        <span className="react-bootstrap-table-pagination-total px-2">
          {from}-{to} de {size} resultados
        </span>
      ) : (
        <span className="react-bootstrap-table-pagination-total px-2">
          Nenhum resultado
        </span>
      ),
  };

  const onHideSelectionIdsModal = (toUpdate) => {
    if (toUpdate) {
      setData((prev) =>
        prev.map((rescue) => {
          if (toUpdate.ids.includes(rescue.id)) {
            rescue.status = +toUpdate.status;
          }

          return rescue;
        })
      );
    }

    setShowSelectionIdsModal(false);
  };

  const onHideModalObsEdit = (toUpdate) => {
    if (toUpdate) {
      setData((prev) =>
        prev.map((rescue) => {
          if (toUpdate.id === rescue.id) {
            rescue.obs = toUpdate.obs;
          }
          return rescue;
        })
      );
    }
    setObs('');
    setShowObsEditModal(false);
  };

  const handlePrevisaoEntregaUpdated = () => {
    buscarResgates(1, 10, termoBusca);
    setMostrarModalEditarPrevisao(false);
    setDataEditarPrevisao(null);
  };

  return (
    <Container fluid>
      <h4 className="pt-3 pb-3 f-black">Resgates</h4>
      <hr className="hr-loja mt-0 mb-4" />
        <ToolkitProvider
          bootstrap4
          keyField="id"
          data={data.map(item => ({
            ...item,
            _isSelected: resgatesSelecionados.includes(Number(item.id)),
            _selectionVersion: tableKey
          }))}
          columns={columns}
        >
          {(props) => (
            <div>
              <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-end mb-3">
                <Col xs={12} sm={6} md={3} lg={2} className="d-flex flex-column mb-2 mb-md-0 pr-md-2">
                  <label htmlFor="redeSelecionada">Selecione uma Rede</label>
                  <select
                    className="input-select"
                    name="redeSelecionada"
                    id="redeSelecionada"
                    onChange={(e) => setRedeSelecionada(e.target.value)}
                    defaultValue=""
                  >
                    <option value="">Todas</option>
                    {redesSelect.map((rede) => (
                      <option value={rede.nome} key={rede.nome}>
                        {rede.nome}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col xs={12} sm={6} md={3} lg={2} className="d-flex flex-column mb-2 mb-md-0 pr-md-2">
                  <label htmlFor="gestorSelecionado">Selecione um Gestor</label>
                  <select
                    className="input-select"
                    name="gestorSelecionado"
                    id="gestorSelecionado"
                    onChange={(e) => setGestorSelecionado(e.target.value)}
                    defaultValue=""
                  >
                    <option value="">Todos</option>
                    {gestoresSelect.map((gestor) => (
                      <option value={gestor.nome} key={gestor.id}>
                        {gestor.nome}
                      </option>
                    ))}
                  </select>
                </Col>
                <div className="d-flex align-items-end mb-2 mb-md-0 pr-md-2">
                  <button
                    onClick={() => setShowSelectionIdsModal(true)}
                    className="btn-primario-slim px-4 d-flex g-4 align-items-center mr-2"
                  >
                    <i className="fas fa-stream mr-2"></i>
                    <span>Alterar Status em Massa</span>
                  </button>
                  {resgatesSelecionados.length > 0 && (
                    <button
                      onClick={enviarManualmente}
                      disabled={enviando}
                      className="btn-primario-slim px-4 d-flex g-4 align-items-center"
                    >
                      {enviando ? (
                        <>
                          <i className="fas fa-circle-notch fa-spin mr-2"></i>
                          <span>Enviando...</span>
                        </>
                      ) : (
                        <>
                          <i className="fas fa-paper-plane mr-2"></i>
                          <span>Enviar Manualmente ({resgatesSelecionados.length})</span>
                        </>
                      )}
                    </button>
                  )}
                </div>
                <div className="d-flex flex-row-reverse align-items-end ml-md-auto">
                  <button
                    className="btn-busca"
                    type="button"
                    onClick={() => buscarResgates(1, pageSize, termoBusca)}
                    style={{ marginBottom: 0 }}
                  >
                    {buscando ? (
                      <i className="fas fa-circle-notch fa-spin"></i>
                    ) : (
                      <i className="fas fa-search"></i>
                    )}
                  </button>
                  <input
                    type="text"
                    value={termoBusca}
                    onChange={(e) => setTermoBusca(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        buscarResgates(1, pageSize, termoBusca);
                      }
                    }}
                    placeholder="Buscar"
                    className="input-theme mr-2"
                  />
                </div>
              </div>
              <BootstrapTable
                key={`table-${data.length}-${tableKey}`}
                noDataIndication={() =>
                  buscando ? (
                    <span>
                      Carregando
                      <i className="fas fa-circle-notch fa-spin ml-3"></i>
                    </span>
                  ) : (
                    <span>Sem resultados</span>
                  )
                }
                classes="table-dark text-center rounded"
                wrapperClasses="rounded"
                bordered={false}
                remote
                pagination={paginationFactory(options)}
                onTableChange={handleTableChange}
                defaultSorted={defaultSorted}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      <ModalCancelarResgate
        show={mostrarModalCancelarResgate}
        onHide={fecharModalCancelarResgate}
        resgate={resgate}
      />
      <ModalAlterarStatusResgate
        show={mostrarModalAlterarStatusResgate}
        onHide={fecharModalAlterarStatusResgate}
        resgate={resgate}
      />
      <ModalMassRescueAlteration
        open={showSelectionIdsModal}
        onHide={onHideSelectionIdsModal}
        resgate={resgate}
      ></ModalMassRescueAlteration>

      <ModalObsEdit
        open={showObsEditModal}
        onHide={onHideModalObsEdit}
        resgate={resgate}
        obs={obs}
        setObs={setObs}
      />

      <ModalEditarPrevisaoEntrega
        show={mostrarModalEditarPrevisao}
        onHide={() => {
          setMostrarModalEditarPrevisao(false);
          setDataEditarPrevisao(null);
        }}
        resgate={dataEditarPrevisao?.id}
        onSuccess={handlePrevisaoEntregaUpdated}
      />
    </Container>
  );
}
